module.exports = __webpack_public_path__ + "2709d41b2684345ae40ce6fcb92c6917.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/vipPay_active.png
// module id = 577
// module chunks = 0